/**
 * <tabbed-testimonials> — tabs widget for testimonial panels.
 *
 * Each panel's testimonials are filtered server-side in Liquid (one panel per
 * category), so this only toggles which panel is visible — no client-side
 * filtering.
 *
 * Behavior:
 * - Clicking a tab shows its panel and hides the others.
 *
 * Keyboard:
 * - Arrow Left/Right move between tabs (roving tabindex)
 * - Home/End jump to first/last
 * - Enter/Space activates current tab
 */

class TabbedTestimonials extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.tabs.forEach((tab, idx) => {
      tab.addEventListener('click', () => this._activate(idx));
      tab.addEventListener('keydown', (e) => this._onKeydown(e, idx));
    });
  }

  _activate(idx) {
    this.tabs.forEach((t, i) => {
      const active = i === idx;
      t.setAttribute('aria-selected', String(active));
      t.setAttribute('tabindex', active ? '0' : '-1');
    });
    this.panels.forEach((p, i) => {
      if (i === idx) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', '');
      }
    });
    this.tabs[idx].focus();
  }

  _onKeydown(e, idx) {
    const lastIdx = this.tabs.length - 1;
    let nextIdx = idx;
    if (e.key === 'ArrowRight') nextIdx = idx === lastIdx ? 0 : idx + 1;
    else if (e.key === 'ArrowLeft') nextIdx = idx === 0 ? lastIdx : idx - 1;
    else if (e.key === 'Home') nextIdx = 0;
    else if (e.key === 'End') nextIdx = lastIdx;
    else return;
    e.preventDefault();
    this._activate(nextIdx);
  }
}

if (!customElements.get('tabbed-testimonials')) {
  customElements.define('tabbed-testimonials', TabbedTestimonials);
}
